import { EventEmitter, Injectable, Output, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IAdministrativeComplaintView, IBusinessExemptInspectionsViewModel } from 'app/models/mainMenu/mainMenu';
import { IBusinessEnclosedAreasViewModel, IBusinessView, INotesViewModel } from 'app/models/business/business';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({ providedIn: 'root' })
export class BusinessService {

  @Output() updateBusinessEvent = new EventEmitter<number>();

  currentBusiness: IBusinessView = {} as IBusinessView;
  businessList: IBusinessView[] = [];
  businessAdminSearch: string = '';
  userSearch: string = '';
  businessId: number = 0;
  businessTab: number = 0;
  businessVisitTab: number = 0;

  currentComplaint: IAdministrativeComplaintView = {} as IAdministrativeComplaintView;

  public api: string = environment.privateApi + 'business/';  

  private http = inject(HttpClient);

  updateTabs(tab:number){
    this.updateBusinessEvent.emit(tab);
  }

  // Proccess Complaint 

  getBusiness(id: number): Observable<IBusinessView> {
    return this.http.get<IBusinessView>(this.api + 'getBusiness/' + id);
  }

  addComplaintFile(form: FormData): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'addComplaintFile', form);
  }

  saveBusinessInfo(business: IBusinessView): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'saveBusinessInfo', business);
  }

  // Business Notes

  getBusinessNotes(id: number): Observable<INotesViewModel[]> {
    return this.http.get<INotesViewModel[]>(this.api + 'getBusinessNotes/' + id);
  }

  addBusinessNote(id:number, notes: INotesViewModel[]): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'addBusinessNote/' + id, notes, httpOptions);
  }

  // Annual Inspection 

  getAnnualInspections(id: number): Observable<IBusinessExemptInspectionsViewModel[]> {
    return this.http.get<IBusinessExemptInspectionsViewModel[]>(this.api + 'getAnnualInspections/' + id);
  }

  saveAnnualInspection(id:number, inspection: IBusinessExemptInspectionsViewModel): Observable<boolean> {
    return this.http.post<boolean>(this.api + 'saveAnnualInspection/' + id, inspection, httpOptions);
  }

  removeInspection(id: number): Observable<boolean> {
    return this.http.get<boolean>(this.api + 'removeInspection/' + id);
  }


}
